export async function indexByClientGuidesUseCase(client_id, per_page, page, status, search, sort_by, guideRepostitory) {
    const result = await guideRepostitory.index_by_client_guides(client_id, per_page, page, status, search, sort_by);

    const entity = new guideRepostitory.model_index(result.data.success.arguments);

    if (!entity.isValid()) {
      throw new Error("Resultado invalido");
    }

    return result;
}